import React, { ReactNode } from 'react';

import FormattedMessage from 'components/formatted-message';
import Icon from 'components/icon';

import styles from '../result-list.module.css';

type ResultWrapperProps = {
    children: ReactNode;
    processing: boolean;
    isNoData: boolean;
};

/** A scrolling list of results with the loader and the "No Data" message */
const ResultWrapper = ({ children, processing, isNoData }: ResultWrapperProps) => {
    const renderContent = () => {
        if (processing) {
            return (
                <div className={styles.loaderBox}>
                    <Icon type="spinner" pulse />
                </div>
            );
        }
        if (isNoData) {
            return (
                <div className={styles.loaderBox}>
                    <FormattedMessage id="searchbar.noData" />
                </div>
            );
        }

        return children;
    };

    return (
        <div className={styles.list}>
            <div className={styles.row}>
                <div className={styles.column}>
                    <div className={styles.container}>{renderContent()}</div>
                </div>
            </div>
        </div>
    );
};

export default ResultWrapper;
